var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassMedium = function SvgIconHourglassMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.85 8.638q.046.039.097.072L10.333 12 5.7 15.475l-.005.004A1.76 1.76 0 0 0 5 16.869v3.381A1.75 1.75 0 0 0 6.75 22h10.5A1.75 1.75 0 0 0 19 20.25v-3.344a1.76 1.76 0 0 0-.695-1.39L13.657 12 18 8.715q.061-.04.116-.088l.187-.142.002-.001A1.76 1.76 0 0 0 19 7.094V3.75A1.75 1.75 0 0 0 17.25 2H6.75A1.75 1.75 0 0 0 5 3.75v3.381a1.76 1.76 0 0 0 .695 1.39l.005.004zM7 6.875V4h10v2.875zm7.473 2-2.476 1.873L9.5 8.875zM11 14l-4 3v3h10v-2.963l-4-3.026v1.739a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassMedium;